import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
extendZodWithOpenApi(z);
const uuidSchema = z.string().uuid('Invalid UUID format');
/** Reorder children within a parent. The array is the full ordered list of child IDs. */
export const ReorderChildrenSchema = z.object({
    orderedIds: z
        .array(uuidSchema)
        .min(1, 'At least one ID is required')
        .openapi({
        description: 'Ordered list of child entity IDs (complete list, not partial)',
        example: ['id-1', 'id-2', 'id-3'],
    }),
});
/** Move a topic to a different module. */
export const MoveTopicSchema = z.object({
    targetModuleId: uuidSchema.openapi({
        description: 'The module to move this topic into',
    }),
    position: z
        .number()
        .int()
        .min(0, 'Position must be >= 0')
        .openapi({
        description: 'Zero-based position within the target module',
        example: 0,
    }),
});
/** Move a lesson to a different topic. */
export const MoveLessonSchema = z.object({
    targetTopicId: uuidSchema.openapi({
        description: 'The topic to move this lesson into',
    }),
    position: z
        .number()
        .int()
        .min(0, 'Position must be >= 0')
        .openapi({
        description: 'Zero-based position within the target topic',
        example: 0,
    }),
});
//# sourceMappingURL=content-management.schema.js.map